import { useContext } from 'react';
import PropTypes from 'prop-types';
import ListingsCarousel from 'components/ListingsCarousel';
import { resolve } from 'styled-jsx/css';
import { screen, colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { trackDealerPagesClick } from 'lib/Tracking/DealerPages';
import { DealerPagesEventType } from 'lib/EventSchema';
import TrackingDataContext from 'contexts/TrackingDataContext';

function listingsLink(remoteId, providerName) {
  return `/listings#remote_dealer_id=${remoteId}&provider_name=${providerName}&radius=any`;
}

const SeeAllListings = ({ total, remoteId, providerName }) => {
  const { t } = useTranslation();
  const { dealerPageUrl } = useContext(TrackingDataContext);
  const link = listingsLink(remoteId, providerName);

  function onClick() {
    trackDealerPagesClick({
      type: DealerPagesEventType.see_all_listings_button_click,
      dealerPageUrl,
      targetPageUrl: link,
    });
  }

  return (
    <a href={link} className="see-all-listings" onClick={onClick}>
      <div>{t('dealerPages.seeAllListings', { total })}</div>
      <style jsx>{`
        .see-all-listings {
          margin-top: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 311px;
          height: 48px;
          border-radius: 8px;
          border: solid 2px ${colors.G1};
          color: ${colors.ALR1};
          font-weight: 600;
          letter-spacing: 0.18px;
        }

        a:hover {
          border: solid 2px ${colors.ALR1};
          background-color: ${colors.ALR1};
          color: white;
        }
      `}</style>
    </a>
  );
};

SeeAllListings.propTypes = {
  total: PropTypes.number.isRequired,
  remoteId: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
};

/* istanbul ignore next */
const headingCSS = resolve`
  .smaller-text {
    font-size: 18px;
  }
`;

function DealerListings({ listings, total, remoteId, providerName }) {
  const { dealerPageUrl } = useContext(TrackingDataContext);

  function onVehicleClick({ position, targetPageUrl }) {
    trackDealerPagesClick({
      type: DealerPagesEventType.listing_click,
      label: position,
      targetPageUrl,
      dealerPageUrl,
    });
  }
  return (
    <div className="dealer-listings">
      <ListingsCarousel listings={listings} onVehicleClick={onVehicleClick} />

      <SeeAllListings
        total={total}
        remoteId={remoteId}
        providerName={providerName}
      />

      <style jsx>{`
        .dealer-listings {
          margin-bottom: 50px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .dealer-listings {
            padding: 0;
            margin-top: 30px;
          }
        }
      `}</style>
      {headingCSS.styles}
    </div>
  );
}

DealerListings.propTypes = {
  listings: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  remoteId: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
};

export default DealerListings;
